import type { WorkOrderChangeObjectResultData, WorkOrderObjectResultData } from 'gql/graphql';
import { formatNumberToRu } from 'utils';

import type React from 'react';

import Styles from './WorkOrderSummaryItem.module.css';

interface IWorkOrderSummaryItemProps {
    item: WorkOrderObjectResultData | WorkOrderChangeObjectResultData;
    costRounding: number;
}

export const WorkOrderSummaryItem: React.FC<IWorkOrderSummaryItemProps> = (props) => {
    const { item, costRounding } = props;

    return (
        <div className={Styles.workOrderSummaryItem}>
            <div className={Styles.workOrderSummaryItemHeader}>{item.title}</div>
            <div className={Styles.workOrderSummaryItemData}>
                {item.costResultData?.map((itemData, index) => (
                    <div key={index} className={Styles.workOrderSummaryItemDataRow}>
                        <div className={Styles.workOrderSummaryItemDataColumnName}>{itemData.name}</div>
                        <div className={Styles.workOrderSummaryItemDataColumnValue}>
                            {formatNumberToRu(Number(itemData.value), costRounding)}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

WorkOrderSummaryItem.displayName = 'WorkOrderSummary';
